import { LocationsContext } from './locations.service';
import { Store } from '@ngrx/store';
import { Broker } from '@c4/core';
import { Injectable } from '@angular/core';
import { ProgrammingUtilsService as Utils } from './utils.service';
import { Room, Location } from './../interfaces/item.interface';
import { Observable } from 'rxjs/Observable';

export interface LocationsContext {
  all?: Map<number, Location>;
  sites?: Location[];
  buildings?: Location[];
  floors?: Location[];
  rooms?: Room[];
  hierarchy?: Map<number, Location>;
}

const STORE_NAME: string = 'LOCATIONS:';
const SET_LOCATION_MAP: string = STORE_NAME + 'SET_LOCATION_MAP';
const SET_SITES: string = STORE_NAME + 'SET_SITES';
const SET_BUILDINGS: string = STORE_NAME + 'SET_BUILDINGS';
const SET_FLOORS: string = STORE_NAME + 'SET_FLOORS';
const SET_ROOMS: string = STORE_NAME + 'SET_ROOMS';

export function locationsReducer(state: LocationsContext = {}, { type, payload }) {
  switch (type) {
    case SET_LOCATION_MAP: return Object.assign({}, state, { all: payload });
    case SET_SITES: return Object.assign({}, state, { sites: payload });
    case SET_BUILDINGS: return Object.assign({}, state, { buildings: payload });
    case SET_FLOORS: return Object.assign({}, state, { floors: payload });
    case SET_ROOMS: return Object.assign({}, state, { rooms: payload });

    default: return state;
  }
};

@Injectable()
export class LocationsService {
  private _brokerObserver: Observable<Location[]>;

  rooms: Observable<Room[]>;
  floors: Observable<Location[]>;

  constructor(
    private broker: Broker,
    private utils: Utils,
    private store: Store<{ locations: LocationsContext }>
  ) {

    this._brokerObserver = this.broker.getObservable<Location[]>({
      path: '/api/v1/locations'
    });

    this.rooms = this.store.select(s => s.locations.rooms);
    this.floors = this.store.select(s => s.locations.floors);

    this._monitor();
  }

  private _monitor() {
    this._monitorBroker();
  }

  private _monitorBroker() {
    this._brokerObserver.subscribe(locations => {
      this._handleUpdates(locations);
    }, err => {
      console.error('locations.svc: error getting locations', err);
    });
  }

  private _handleUpdates(locations: Location[]) {
    // set map of all locations, for easy lookup
    let all = new Map<number, Location>();
    locations.forEach(loc => {
      all.set(loc.id, loc);
    });
    console.log('loc.svc: debug, first floor is ', all.get(11));
    this.store.dispatch({ type: SET_LOCATION_MAP, payload: all });

    this.store.dispatch({ type: SET_SITES, payload: locations.filter(loc => loc.type === 2) });
    this.store.dispatch({ type: SET_BUILDINGS, payload: locations.filter(loc => loc.type === 3) });
    this.store.dispatch({ type: SET_FLOORS, payload: locations.filter(loc => loc.type === 4) });
    this.store.dispatch({ type: SET_ROOMS, payload: locations.filter(loc => loc.type === 8) });

    // TODO build location hierarchy
  }

  getLocationById(id: any): Location {
    // console.log('locs.svc: getting location by id', id);
    let locId = parseInt(id);
    if (!isNaN(locId)) {
      let all = this.utils.getValue(this.store, s => s.locations.all);
      if (all) {
        return all.get(locId);
      } else {
        return undefined;
      }
    } else {
      return undefined;
    }
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/common/services/locations.service.ts